import * as React from 'react';

import ResultList from '../components/ResultList';
import ResultListHeader from '../components/ResultListHeader';

import {
  IHit,
  ISearchReply,
  ISearchRequest,
} from '../api/SubtitlesAPI';

import './SearchResultsPage.css';

import { connect } from 'react-redux';

import {
  moreResults,
  playClip,
} from '../thunks';
import { RootState } from '../types';


interface IProps {
  currentRecordingID: string | null,
  error: Error | null,
  isAtEnd: boolean,
  isLoading: boolean,
  onPreview: (i: IHit) => void,
  onMoreResults: () => void,
  onSelect: (recID: string) => void,
  query: ISearchRequest | null,
  results: ISearchReply[],
  resultsTotal: number | null,
}

class SearchResultsPage extends React.Component<IProps> {

  private resultList: HTMLDivElement | null = null;

  constructor(props: IProps) {
    super(props);
  }

  public async componentWillMount() {
    window.addEventListener('scroll', this.checkLazyLoad);
    window.addEventListener('resize', this.checkLazyLoad);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.checkLazyLoad);
    window.removeEventListener('resize', this.checkLazyLoad);
  }

  public render() {
    const {
      currentRecordingID,
      error,
      isAtEnd,
      isLoading,
      onPreview,
      query,
      results,
      resultsTotal,
    } = this.props;

    const lists = results.map((r, i) =>
      <ResultList
        key={ i }
        onPreview={ onPreview }
        onSelect={ this.onSelect }
        currentRecordingID={ currentRecordingID }
        results={ r } />);

    let resultList = null;
    if (query) {
      resultList = (<div>
                      <ResultListHeader
                                        isLoading={ isLoading }
                                        query={ query.query }
                                        resultCount={ resultsTotal } />
                      <div ref={(el) => this.resultList = el} id="result-list">
                        { lists }
                      </div>
                    </div>);
    }

    return (
      <div className="search-results-page container">
        <div id="results">
          { resultList }
          { error ? <div className="search-error">
                                 { error.message }
                               </div> : null }
          { isLoading ? <div className="list-loading">
                                     Loading...
                                   </div> : null }
          { isAtEnd ? <div className="list-end">
                                   End of Results
                                 </div> : null }
        </div>
      </div>
      );
  }


  private checkLazyLoad = () => {
    const {
      onMoreResults,
      isLoading,
      isAtEnd,
    } = this.props;

    const { resultList } = this;
    if (!resultList) {
      return;
    }

    const winBottom = window.scrollY + window.innerHeight;
    const listBottom = resultList.offsetTop + resultList.offsetHeight;
    const scrolledNearBottom = (listBottom - winBottom) < window.innerHeight;

    if (scrolledNearBottom && !isLoading && !isAtEnd) {
      onMoreResults();
    }
  }

  private onSelect = (selection: IHit) => {
    const {onSelect} = this.props;

    onSelect(selection.recording_id);
  }

}

export const SearchResultsContainer = connect(
  ({player, search}: RootState) => {
    const {
      query,
      resultsTotal,
      results,
      isLoading,
      error,
    } = search;

    const isAtEnd =
      resultsTotal !== null &&
      query !== null &&
      query.offset !== undefined &&
      query.offset >= resultsTotal;

    return {
      currentRecordingID: player.recordingId,
      error,
      isAtEnd,
      isLoading,
      query,
      results,
      resultsTotal,
    };
  },
  dispatch => ({
    onMoreResults: () => { dispatch<any>(moreResults()) },
    onPreview: (selection: IHit) => { dispatch<any>(playClip(selection)) },
    onSelect: (trackID: string) => alert(trackID),
  }),
)(SearchResultsPage);
export default SearchResultsContainer;



// WEBPACK FOOTER //
// ./src/pages/SearchResultsPage.tsx